import * as React from 'react';
import { RouteObject } from 'react-router-dom';

const ClientSettings = React.lazy(
    () => import(/* webpackChunkName: "client-settings" */ '../../../../containers/Client/Settings')
);
const SelfSettings = React.lazy(
    () => import(/* webpackChunkName: "settings-self" */ '../../../../containers/Shared/Self')
);

export const ClientSettingsRoutes: RouteObject = {
    path: 'settings',
    element: (
        <React.Suspense fallback={<>...</>}>
            <ClientSettings />
        </React.Suspense>
    ),
    children: [
        {
            index: true,
            element: (
                <React.Suspense fallback={<>...</>}>
                    <SelfSettings />
                </React.Suspense>
            )
        }
    ]
};
